import script from "./InternalChatPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./InternalChatPopup.vue?vue&type=script&setup=true&lang=ts"

import "./InternalChatPopup.vue?vue&type=style&index=0&id=fd050e06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd050e06"]])

export default __exports__